import { darkModeIconSm, lightModeIconSm } from '@tpct/icons';

type Theme = 'light' | 'dark';

type ThemeToggleProps = {
  value: Theme;
  onChange: (theme: Theme) => void;
};

const ThemeToggle = ({ value, onChange }: ThemeToggleProps) => {
  const isLight = value === 'light';

  return (
    <button
      type="button"
      className="theme-toggle"
      role="switch"
      aria-checked={!isLight}
      aria-label={isLight ? 'Activer le mode sombre' : 'Activer le mode clair'}
      onClick={() => onChange(isLight ? 'dark' : 'light')}
    >
      <span className="theme-toggle__track">
        <span
          className={`theme-toggle__thumb${isLight ? '' : ' theme-toggle__thumb--dark'}`}
          aria-hidden="true"
        />
        <span
          className={`theme-toggle__icon${isLight ? ' theme-toggle__icon--active' : ''}`}
          aria-hidden="true"
        >
          <img src={lightModeIconSm} alt="" className="theme-toggle__icon-img" />
        </span>
        <span
          className={`theme-toggle__icon${!isLight ? ' theme-toggle__icon--active' : ''}`}
          aria-hidden="true"
        >
          <img src={darkModeIconSm} alt="" className="theme-toggle__icon-img" />
        </span>
      </span>
    </button>
  );
};

export default ThemeToggle;
